import React, { useEffect } from 'react';
import { Formik } from 'formik';
import { connect } from 'react-redux';
// [redux -- users]

import {
  usersAsValueAndLabelSelectors,
  usersIsLoadingSelector,
} from '../../../modules/users/Selectors';

import { getUsersAction } from '../../../modules/users/Actions';

// [redux -- supplier]
import {
  createSupplierAction,
  updateSupplierAction,
  getSupplierAction,
} from '../../../modules/suppliers/Actions';

import {
  suppliersIsLoadingSelector,
  supplierByIdSelector,
} from '../../../modules/suppliers/Selectors';

// [redux -- supplier categories]
import { getSupplierCategoriesAction } from '../../../modules/supplierCategories/Actions';
import {
  supplierCategoriesListSelector,
  supplierCategoriesIsLoadingSelector,
} from '../../../modules/supplierCategories/Selectors';

import {
  FormGroup,
  InputField,
  Upload,
  TextArea,
  Select,
  SearchableSelect,
  CheckBox,
  FormSectionTitle,
  Separator,
} from '../../../components/form/';

import WorkingHours from '../../../components/form/WorkingHours';

import SupplierBIOi18n from './SupplierBIOi18n';
import Schema from './suppliersSchema';
import setWizardPage from '../../../helpers/setWizardPage';
import getLangData from '../../../utils/getLangData';

const companySizeOptions = [
  {
    label: '1-10',
    value: '1-10',
  },
  {
    label: '10-100',
    value: '10-100',
  },
  {
    label: '100-1000',
    value: '100-1000',
  },
  {
    label: 'More Than 1000',
    value: '1000+',
  },
];

const options = [
  {
    value: ['0'],
    label: 'Manufacturer',
  },
  {
    value: ['1'],
    label: 'Distributor',
  },
];

const SuppliersForm = (props) => {
  // users
  const { mappedUsers, getUsers, usersIsLodaing } = props;

  // suppliers
  const {
    createSupplier,
    getSupplier,
    updateSupplier,
    supplier,
    supplierId,
    suppliersIsLoading,
    page,
    setPage,
  } = props;

  // categories
  const { categories, getCategories, categoriesIsLoading } = props;

  useEffect(() => {
    getUsers();
    getCategories({ size: 50 });
    if (supplierId) {
      getSupplier(supplierId);
      getCategories({ size: 50 });
    }
  }, [getSupplier, supplierId]);

  // if (page.indexOf('4') === -1) return <div></div>;
  const lang = getLangData().fields
  return (
    <Formik
      validationSchema={Schema()}
      initialValues={supplier ? { ...supplier } : Schema().cast()}
      onSubmit={(values) => {
        const supplierCID = values.supplierCID.map((cid) =>
          typeof cid === 'object' ? cid._id : cid
        );

        const userID = values.userID._id;
        const geolocation = [-2.777434, 53.7222317];
        if (supplier) {
          updateSupplier(supplierId, {
            ...values,
            supplierCID,
            userID,
            geolocation,
          });
        } else {
          // createSupplier({ ...values, supplierCID, userID , geolocation });
          setWizardPage(page, '5', setPage)
          // console.log('submit', newPage, [...newPage]);
        }
      }}
    >
      {({ values, handleSubmit, errors }) => (
        <FormGroup
          isLoading={suppliersIsLoading}
          heading={
            supplier ? `${lang.update} ${supplier.businessName}` : lang.create_supplier
          }
          handleSubmit={handleSubmit}
        >
          <FormSectionTitle>{lang.basic_information} :</FormSectionTitle>
          <SearchableSelect
            isLoading={usersIsLodaing}
            options={mappedUsers}
            getItems={getUsers}
            name="userID"
            label={lang.user}
            optionLabel={(option) => `${option.firstName} ${option.lastName}`}
          />
          <SearchableSelect
            isMulti={true}
            options={categories}
            getItems={getCategories}
            name="supplierCID"
            label={lang.supplier_category}
            isLoading={categoriesIsLoading}
          />
          <InputField name="businessName" label={lang.business_name} />
          <Select
            options={options}
            name="businessType"
            label={lang.busience_type}
            inArray={true}
          />

          <Upload
            data={{ customerID: 'suads9123213k219d123' }}
            name="logo"
            label={`${lang.profile_logo} : `}
            S3Bucket="warshatna-users"
            API="customer/customer-category-image-signedurl/"
          />

          <TextArea name="supplierBIO" label={lang.supplier_bio} />
          <SupplierBIOi18n name="supplierBIOi18n" />
          <Separator />
          <FormSectionTitle>{lang.basic_information}</FormSectionTitle>
          <CheckBox
            name="onlineStore"
            label={lang.online_store}
            subLabel="I have Online Store."
          />
          <CheckBox
            name="offlineStore"
            label={lang.offline_store}
            subLabel="I have Offline Store."
          />
          <InputField name="yearEstablished" label={lang.year_established} />
          <CheckBox
            name="regCompany"
            label={lang.registered_company}
            subLabel="I have Registered Company."
          />
          <Select
            options={companySizeOptions}
            name="companySize"
            label={lang.company_size}
          />
          {
            // Bio
          }
          <Separator />
          <FormSectionTitle>{lang.contact_person_details}</FormSectionTitle>
          <InputField name="contactPerson" label={lang.contact_person} />
          <InputField name="contactPersonTitle" label={lang.contact_person_title} />
          <InputField name="contactPersonPhone" label={lang.contact_person_phone} />
          <InputField name="contactPersonEmail" label={lang.contact_person_email} />
          <Separator />
          <FormSectionTitle>{lang.company_and_store}</FormSectionTitle>
          <InputField name="website" label={lang.website} />
          <InputField name="facebook" label={lang.faceBook} />
          <InputField name="instagram" label={lang.instagram} />
          <InputField name="youtube" label={lang.youtube} />
          <Separator />
          <FormSectionTitle>{lang.working_hours} :</FormSectionTitle>
          <WorkingHours name="workingHours" />
          {/*   
        <Switch name='workingHours.monday' subLabel={'Mon'} />

 */}
          <Separator />
          <FormSectionTitle> {lang.supplier_status}:</FormSectionTitle>
          <CheckBox name="verified" label={lang.verified} />
          <CheckBox name="trusted" label={lang.trusted} />
          <CheckBox name="moderated" label={lang.moderated} />
        </FormGroup>
      )}
    </Formik>
  );
};

const mapStateToProps = (state, props) => {
  const supplierId = props?.match?.params.id;
  return {
    // users
    mappedUsers: usersAsValueAndLabelSelectors(state),
    usersIsLodaing: usersIsLoadingSelector(state),
    //suppliers
    // supplierId,
    suppliersIsLoading: suppliersIsLoadingSelector(state),
    // supplier: supplierByIdSelector(state, supplierId),
    // categories
    categories: supplierCategoriesListSelector(state),
    categoriesIsLoading: supplierCategoriesIsLoadingSelector(state),
  };
};

const mapDispatchToProps = {
  // users
  getUsers: getUsersAction,

  // suppliers
  createSupplier: createSupplierAction,
  updateSupplier: updateSupplierAction,
  getSupplier: getSupplierAction,
  // categories
  getCategories: getSupplierCategoriesAction,
};
export default connect(mapStateToProps, mapDispatchToProps)(SuppliersForm);
